import $ from 'jquery/src/jquery'

export default () => {
    const sel = {
        root: '[js-gallery="container"]',
        list: '[js-gallery="gallery"]',
        item: '[js-gallery="item"]',
        filter: '[js-gallery="filter"]',
    }

    function init() {
        const $roots = $(sel.root)
        if (!$roots.length) return

        $roots.each(function () {
            const $root = $(this)
            const $list = $root.find(sel.list)
            if (!$list.length) return

            // cache original items
            const $items = $list.children(sel.item).detach()

            // first render
            $list.append($items)

            // filter handler
            $root.on('change', sel.filter, function () {
                $list.addClass('is-filtering')

                const value = this.value

                setTimeout(function () {
                    const $filtered =
                        value === 'all'
                            ? $items
                            : $items.filter(function () {
                                return $(this).data('js-gallery--category') === value
                            })

                    $list.empty().append($filtered)

                    $list.removeClass('is-filtering')
                }, 300)
            })
        })
    }

    return Object.freeze({ init })
}
